import { axiosClient } from '@/features'
import { ApiRoutes } from '@/routes'
import { getUrl } from '@/shared/helpers/url'
import { TransactionData, TransactionRequest } from '@/features/Transactions/transactions.types'

export const transactionsService = {
  getList: async (data: TransactionRequest): Promise<TransactionData[]> => {
    const defaultParams: TransactionRequest = { size: 5 }
    const params: TransactionRequest = { ...defaultParams, ...data }
    const request = await axiosClient.post(ApiRoutes.GET_TRANSACTIONS_LIST, { ...params })
    return request.data
  },

  getDetails: async <T>(txId: string): Promise<T> => {
    const request = await axiosClient.get<T>(getUrl(ApiRoutes.GET_TRANSACTION_DETAILS, { id: txId }))
    return request.data
  },
}
